import { campaignObjectiveLabel, CampaignObjectiveValue } from './../../const/state/campaign';
import { CampaignObjectiveType } from '@ad/tt_ads_common_enums';

export const objectiveTypes = [
  {
    size: 8,
    activeColor: false,
    border: false,
    title: 'module_reach_title',
    tips: 'module_reach_hint',
    value: CampaignObjectiveValue.Reach,
    blockId: CampaignObjectiveValue.Reach,
    backgroundColor: '#f8f8f9',
    isNewPromotion: false,
    hasLink: false,
    teaName: 'data-tea-objective-content',
    teaContent: campaignObjectiveLabel[CampaignObjectiveValue.Reach],
    icon: require('../../../src/assets/images/objective/reach_new.png'),
  },
  {
    size: 8,
    activeColor: false,
    border: false,
    title: 'module_videoview_title',
    tips: 'module_videoview_hint',
    value: CampaignObjectiveValue.VideoView,
    blockId: CampaignObjectiveValue.VideoView,
    backgroundColor: '#f8f8f9',
    isNewPromotion: false,
    hasLink: false,
    teaName: 'data-tea-objective-content',
    teaContent: campaignObjectiveLabel[CampaignObjectiveValue.VideoView],
    icon: require('../../../src/assets/images/objective/videoview_new.png'),
  },
  {
    size: 8,
    activeColor: false,
    border: false,
    title: 'module_traffic_title',
    tips: 'module_traffic_hint',
    value: CampaignObjectiveValue.Traffic,
    blockId: CampaignObjectiveValue.Traffic,
    backgroundColor: '#f8f8f9',
    isNewPromotion: false,
    hasLink: false,
    teaName: 'data-tea-objective-content',
    teaContent: campaignObjectiveLabel[CampaignObjectiveValue.Traffic],
    icon: require('../../../src/assets/images/objective/traffic_new.png'),
  },
  {
    size: 8,
    activeColor: false,
    border: false,
    title: 'module_engagement_title',
    tips: 'module_engagement_hint',
    value: CampaignObjectiveValue.CommunityInteraction,
    blockId: CampaignObjectiveValue.CommunityInteraction,
    backgroundColor: '#f8f8f9',
    isNewPromotion: false,
    hasLink: false,
    teaName: 'data-tea-objective-content',
    teaContent: campaignObjectiveLabel[CampaignObjectiveValue.CommunityInteraction],
    icon: require('../../../src/assets/images/objective/engagement_new.png'),
  },
  {
    size: 8,
    activeColor: false,
    border: false,
    title: 'module_leads_title',
    tips: 'module_leads_hint',
    value: CampaignObjectiveValue.LeadAds,
    blockId: CampaignObjectiveValue.LeadAds,
    backgroundColor: '#f8f8f9',
    isNewPromotion: false,
    hasLink: false,
    teaName: 'data-tea-objective-content',
    teaContent: campaignObjectiveLabel[CampaignObjectiveValue.LeadAds],
    icon: require('../../../src/assets/images/objective/lead-ads_new.png'),
  },
];

export const auctionObjectiveType: number[] = [
  CampaignObjectiveType.TRAFFIC,
  CampaignObjectiveType.APPINSTALL,
  CampaignObjectiveType.CONVERSION,
  CampaignObjectiveType.VIDEOVIEW,
  CampaignObjectiveType.REACH,
  CampaignObjectiveType.LEADADS,
  CampaignObjectiveType.ENGAGEMENT,
  CampaignObjectiveType.APP_PROMOTION,
  CampaignObjectiveType.PRODUCT_SALES,
];

export enum AbTestStatus {
  TESTING_CREATE = 10,
  TEST_END_FAIL = 20,
  TEST_END_SUC = 21,
}

export enum ExternalType {
  NONE = 0,
  WEBSITE = 102,
  ANDRIOD_APP = 201,
  IOS_APP = 202,
  BRAND_PURE_EXPOSURE = 12,
  DPA_DEEP_LINK = 501,
  LEAD_ADS = 601,
  /** 下沉后的 reach/vv 的 external_type 为这个枚举值，表明可能是落地页也可能是品牌纯曝光 */
  EXTERNAL_OR_DISPLAY = 602,
  SHOP_VIDEO = 304,
  SHOP_LIVE = 305,
}

export const supportMobileCreationType = [
  CampaignObjectiveValue.LeadAds,
  CampaignObjectiveValue.CommunityInteraction,
  CampaignObjectiveValue.Traffic,
];
